import { useEffect, useMemo } from 'react';
import { useNavContext } from '../nav-context.js';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const DEFAULT_COLLAPSE_WIDTH = 960;
const useAutoNumber = /* @__PURE__ */ __name(({ auto }) => useMemo(() => {
  if (auto === true) {
    return DEFAULT_COLLAPSE_WIDTH;
  }
  return auto;
}, [auto]), "useAutoNumber");
const NavCollapseAuto = /* @__PURE__ */ __name(({ auto }) => {
  const collapseWidth = useAutoNumber({ auto });
  const { setIsCollapsed } = useNavContext();
  useEffect(() => {
    const observer = new ResizeObserver(([entry]) => {
      if (entry && setIsCollapsed) {
        const {
          contentRect: { width }
        } = entry;
        setIsCollapsed(width < collapseWidth);
      }
    });
    observer.observe(document.body);
    return () => {
      observer.unobserve(document.body);
    };
  }, [setIsCollapsed, collapseWidth]);
  return null;
}, "NavCollapseAuto");

export { NavCollapseAuto };
//# sourceMappingURL=auto.js.map
